<template>
    <div class="number">
        <input type="number" :required="config.required"
               class="tw-border-0 tw-border-b tw-bg-transparent focus:tw-outline-none focus:tw-ring-0"
               :style="inputStyles"
               ref="input"
               :value="value"
               :readonly="readonly"
               @keyup="onAnswerInput" @paste="onAnswerInput">
    </div>
</template>

<script>
export default {
    name: 'QuestionNumber',
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        inputStyles: {
            type: Object,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            required: true
        },
    },
    watch: {
        value: {
            handler(value) {
                this.answer(value);
            },
            immediate: true
        },
    },
    methods: {
        onAnswerInput(event) {
            this.answer(event.target.value);
        },
        answer(value) {
            this.$emit('answer', {
                value: value,
                valid: !/\D/.test(value)
            });
        }
    },
}
</script>
